import(/* webpackMode: "eager" */ "/app/src/app/category/page.tsx");
